import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import {
    shippingReturnsTitle,
    shippingTitle,
    returnPolicyTitle,
    paymentsTitle,
    invoiceTitle,
} from '../messages/pdpDetailsMessages';
import PdpSharedDetailShipping from '../PdpSharedDetails/PdpSharedDetailShipping';
import PdpSharedDetailReturnPolicy from '../PdpSharedDetails/PdpSharedDetailReturnPolicy';
import PdpSharedDetailPayments from '../PdpSharedDetails/PdpSharedDetailPayments';
import PdpSharedDetailItemInvoice from '../PdpSharedDetails/PdpSharedDetailItemInvoice';
import PdpSharedDepositPaymentDetail from '../PdpSharedDetails/PdpSharedDepositPaymentDetail';
import PdpRespDetail from './PdpRespDetail';

// styles
import styles from './PdpRespDetails.scss';

function PdpRespShippingReturns({
    currency,
    relayVariables,
    viewer,
    item,
    user,
    localDeliveryOptions,
    domesticDeliveryOptions,
}) {
    return (
        <div className={styles.wrapper}>
            <h2 className={styles.header}>{shippingReturnsTitle}</h2>
            <div className="rowFlex">
                <ul className="colLg6 colXs12">
                    {/* Shipping */}
                    <PdpRespDetail title={shippingTitle}>
                        <PdpSharedDetailShipping
                            currency={currency}
                            userId={relayVariables.userId}
                            itemId={relayVariables.itemId}
                            viewer={viewer}
                            user={user}
                            localDeliveryOptions={localDeliveryOptions}
                            domesticDeliveryOptions={domesticDeliveryOptions}
                        />
                    </PdpRespDetail>
                    {/* Return Policy */}
                    <PdpRespDetail title={returnPolicyTitle}>
                        <PdpSharedDetailReturnPolicy
                            userId={relayVariables.userId}
                            itemId={relayVariables.itemId}
                            item={item}
                        />
                    </PdpRespDetail>
                </ul>
                <ul className="colLg6 colXs12">
                    {/* Online Payment Methods */}
                    <PdpRespDetail title={paymentsTitle}>
                        <PdpSharedDetailPayments
                            currency={currency}
                            viewer={viewer}
                            user={user}
                            item={item}
                        />
                    </PdpRespDetail>
                    {/* Item Invoice */}
                    <PdpSharedDepositPaymentDetail
                        userId={relayVariables.userId}
                        item={item}
                        wrapper={PdpRespDetail}
                    />
                    {viewer.isItemInvoiceEnabled && (
                        <PdpRespDetail title={invoiceTitle}>
                            <PdpSharedDetailItemInvoice itemId={relayVariables.itemId} />
                        </PdpRespDetail>
                    )}
                </ul>
            </div>
        </div>
    );
}

PdpRespShippingReturns.propTypes = {
    currency: PropTypes.string,
    relayVariables: PropTypes.shape({
        userId: PropTypes.string,
        itemId: PropTypes.string.isRequired,
    }).isRequired,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
    localDeliveryOptions: PropTypes.object,
    domesticDeliveryOptions: PropTypes.object,
};

export default createFragmentContainer(PdpRespShippingReturns, {
    viewer: graphql`
        fragment PdpRespShippingReturns_viewer on Viewer {
            ...PdpSharedDetailShipping_viewer
            ...PdpSharedDetailPayments_viewer
            isItemInvoiceEnabled: isEnabledByLocale(featureName: "INVOICE")
        }
    `,
    user: graphql`
        fragment PdpRespShippingReturns_user on User {
            ...PdpSharedDetailShipping_user
            ...PdpSharedDetailPayments_user
        }
    `,
    item: graphql`
        fragment PdpRespShippingReturns_item on Item {
            ...PdpSharedDetailPayments_item
            ...PdpSharedDetailReturnPolicy_item
            ...PdpSharedDepositPaymentDetail_item
        }
    `,
    localDeliveryOptions: graphql`
        fragment PdpRespShippingReturns_localDeliveryOptions on ShipmentQuoteConnection {
            ...PdpSharedDetailShipping_localDeliveryOptions
        }
    `,
    domesticDeliveryOptions: graphql`
        fragment PdpRespShippingReturns_domesticDeliveryOptions on ShipmentQuoteConnection {
            ...PdpSharedDetailShipping_domesticDeliveryOptions
        }
    `,
});
